<template>
  <v-card density="compact" elevation="4" :width="$isMobile() ? '85%' : 'auto'" class="ma-auto">
    <v-card color="primary" density="compact" variant="outlined">
      <v-img @click="$router.push(`/vaquejadas/${id}/detalhes`)" v-if="logo === ''" :src="getImgPadrao" cover width="100%" />
      <v-img @click="$router.push(`/vaquejadas/${id}/detalhes`)" v-else :src="getUrl + '/images/vaquejadas/' + logo" cover width="100%" />
      <v-card-text style="color: black; margin-top: 0 !important; padding-top: 10px !important; padding-bottom: 0 !important;">
        <h2 style="text-align: center; margin: 15px 0; color: #1867C0">{{ nome }}</h2>
        <h4 style="text-align: center; font-weight: normal">
          <v-icon icon="mdi-map-marker" size="small" />
          {{ cidade.nome }} - {{ cidade.estado }}
        </h4>
        <h5 style="color: grey; font-weight: normal; text-align: center; margin-bottom: 10px; display: flex; align-items: center; justify-content: center; gap: 5px">
          <v-icon icon="mdi-calendar" size="small" />
          {{ getDateStringFormated }}
        </h5>
      </v-card-text>
      <v-card-actions>
        <v-btn style="margin-bottom: 5px" block color="success" variant="elevated" @click="$router.push(`/vaquejadas/${id}/detalhes`)">Ver Detalhes</v-btn>
      </v-card-actions>
    </v-card>
  </v-card>
</template>

<script lang="ts">
  import logoPadrao from '@/assets/logo.png';

  export default {
    name: 'VaquejadaCard',
    props: {
      id: {
        type: Number,
        required: true
      },
      nome: {
        type: String,
        required: true
      },
      dataInicio: {
        type: String,
        required: true
      },
      dataFim: {
        type: String,
        required: true
      },
      limiteSenhasVaqueiro: {
        type: Number,
        required: true
      },
      cidade: {
        type: { nome: String, estado: String },
        required: true
      },
      categorias: {
        type: Array<{ id: Number, nome: String, limiteSenhas: Number, valor: Number }>,
        required: true
      },
      valorBoi: {
        type: Number,
        required: true
      },
      quantidadeSenhas: {
        type: Number,
        required: true
      },
      logo: {
        type: String,
        required: true
      },
      quantidadeDias: {
        type: Number,
        required: true
      }
    },
    computed: {
      getDateStringFormated() {
        const anoInicio = this.dataInicio.split('-')[0];
        const anoFim = this.dataFim.split('-')[0];

        if (anoInicio === anoFim) {
          const mesInicio = this.dataInicio.split('-')[1];
          const mesFim = this.dataFim.split('-')[1];
          const diaInicio = this.dataInicio.split('-')[2].split('T')[0];
          const diaFim = this.dataFim.split('-')[2].split('T')[0];

          const meses = ['JAN', 'FEV', 'MAR', 'ABR', 'MAI', 'JUN', 'JUL', 'AGO', 'SET', 'OUT', 'NOV', 'DEZ'];
          if (this.quantidadeDias === 1) {
            return `${diaInicio} ${meses[Number(mesInicio) - 1]} | ${anoInicio}`
          }
          return `${diaInicio} ${meses[Number(mesInicio) - 1]} - ${diaFim} ${meses[Number(mesFim) - 1]} | ${anoInicio}`
        } else {
          return `${this.dataInicio.split('T')[0].split('-').reverse().join('/')} - ${this.dataFim.split('T')[0].split('-').reverse().join('/')}`
        }
      },
      getUrl() {
        return this.getBaseUrl();
      },
      getImgPadrao() {
        return logoPadrao;
      }
    }
  }
</script>

<style scoped>

</style>
